module.exports = __webpack_public_path__ + "img/gallery-image-02.ee596692.png";